import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  name: {
    id: "HAlOn1",
    defaultMessage: "Name",
  },
});
